module.exports = __webpack_public_path__ + "img/not-finished.d93ed332.png";